import React from 'react';
import { withNavList } from 'react-skeletal-nav';
import cx from 'classnames';

import NavItem from '../NavItem';

import './NavList.scss';

const NavList = withNavList(({ children, title, route }) => (
  <ul className={cx('navigation__list', {
    'navigation__list--root': route === 'root',
    'navigation__list--child': route !== 'root',
  })}>
    {title && <NavItem title={title} asTitle />}
    {children}
  </ul>
));

export default NavList;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Navigation/NavList/NavList.js